import * as React from 'react';
import { createRoot } from 'react-dom/client';

import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';

import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

import * as Bs4Utils from '../Bs4Components/Bs4Utils'
import Bs4MainDispatch from '../Bs4MainDispatch'

function getValue(value) {
  if(!value || value == "0001-01-01" || value == "0000-00-00" || value?.startsWith('-')) {
    return ''; 
  }                

  value = String(value || '')

  //Czy v zawiera inne znaki niż cyfrt (0-9) 
  if((value.match(/[^0-9]/g) || []).length > 0) {
    // tak - prawdopodobnie iso format
    return Bs4Utils.toDate(value)
  }else {             
    // nie - prawdopodobnie unix format 
    return Bs4Utils.toDate(new Date(1000 * parseInt(value)))
  }        
}

export const formatterDate = (cell, formatterParams, onRendered) => {
	return getValue(cell.getValue());
}

export function editorDate(cell, onRendered, success, cancel, editorParams) {
  const editor = document.createElement("div");  
  const styleBorder = cell.getElement().style.border
  cell.getElement().style.border = 'none';

  const root = createRoot(editor);
  
  const bs4Success = (value) => {
    cell.getElement().style.border = styleBorder;
    try {
      root.unmount()
    } catch (error) {
      console.log('unmout error', error)
    }    
    if (getValue(cell.getValue()) === getValue(value)) cancel();
    else success(value);
  }

  onRendered(() => {
    root.render(
      <ViewComponentDate
        value={getValue(cell.getValue())} 
        editorParams={editorParams}
        bs4Success={bs4Success}
        cancel={cancel}
        cell={cell}
      />);      
  });
  
  return editor;
}

const ViewComponentDate = (props) => {  
  const [value, setValue] = React.useState(Bs4Utils.getValidDate(getValue(props.value)));
  const [open, setOpen] = React.useState(false);
  const inputRef = React.useRef();
  const awayRef = React.useRef({
    mouseTextField: true,
    mousePopper: true,
    lastKey: null,
  });
  
  const onchange = (newValue) => {
    setValue(newValue)
  }

  const onOpen = () => {
    setOpen(true)
  }

  const onClose = () => {
    setTimeout(() => inputRef.current.focus(), 100);
    setOpen(false)
  }  

  const onBlurPopper = (e) => {
    if (awayRef.current.mousePopper && !awayRef.current.lastKey) {
       props.bs4Success(Bs4Utils.toDate(value));
    }
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    e.stopPropagation();
    awayRef.current.lastKey = null;
  }
  
  const onBlurTextField = (e) => {
    if ((!open && awayRef.current.mouseTextField)) {
       props.bs4Success(Bs4Utils.toDate(value));
    }
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    e.stopPropagation();
  }

  const onKeyDownTextField = (e) => {
    switch(e.keyCode){
      case 13: //Enter
        props.bs4Success(Bs4Utils.toDate(value));
        break;

      case 9: //Tab
        awayRef.current.mouseTextField = true
        break;

      case 27:  //Esc
        props.cancel();
        break;

      case 38: //up arrow
      case 40: //down arrow
        if (open || (props?.editorParams?.verticalNavigation == "editor")){
          if (e.stopImmediatePropagation) e.stopImmediatePropagation();
          e.stopPropagation();
        } else {          
          awayRef.current.mouseTextField = true
        }
        break;

      case 35:
      case 36:
        e.stopPropagation();
        break;
    }
  }  

  React.useEffect(() => {    
    if (props.cell?.getRow()) props.cell.getRow().normalizeHeight()
  }, [props.cell]);

  const [xx, xxXX] = Bs4MainDispatch.useBs4Locale();

  return (
    <LocalizationProvider 
      dateAdapter={AdapterDateFns} 
      adapterLocale={xx}
      localeText={xxXX.components.MuiLocalizationProvider.defaultProps.localeText}
    >
      <Box overflow={'hidden'}> 
        <DatePicker                      
          onOpen={onOpen}
          onClose={onClose}
          value={value}
          format="yyyy-MM-dd"
          onChange={(newValue) => onchange(newValue)}
          inputRef={inputRef}          
          slotProps={{
            actionBar: {
              actions: ['today']
            },
            popper: {
              onBlur: onBlurPopper,
              onMouseEnter: (e) => awayRef.current.mousePopper = false,
              onMouseLeave: (e) => awayRef.current.mousePopper = true,
              onKeyDown: (e) => awayRef.current.lastKey = e.keyCode,
            },
            textField: {
              onBlur: onBlurTextField,
              onMouseEnter: (e) => awayRef.current.mouseTextField = false,
              onMouseLeave :(e) => awayRef.current.mouseTextField = true,
              onKeyDown: onKeyDownTextField,
              autoFocus: true,
              margin: 'dense',
              size: 'small',
              fullWidth: true,
              variant: "outlined",
              sx: {mt:'2px', mb:'1px', my:'1px', '& input': { padding: 0.5}},
            }
          }}
        />
      </Box>
    </LocalizationProvider>
  );
}